import { MouseEventHandler, useRef } from 'react';
import classNames from 'classnames';
import { Button, Icon, pushNotification } from '@whitesharx/starfall-frontend-ui-kit';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import SayKitWeb from '@whitesharx/starfall-frontend-saykit-web';
import { copyText, Routes, toMovesPairs, usePlayerQuery, useServices } from '@whitesharx/starfall-frontend-core';
import { useAtom } from '@reatom/npm-react';
import { getAnalysisGameAction, selectedMoveAtom } from '../../model';
import {
  buttonIconStyles,
  buttonStyles,
  copyButtonStyles,
  footerButtonsStyles,
  playButtonStyles,
  playLinkStyles,
} from './styles.css';

const PlayFromPositionButton = () => {
  const { RouterLink, Adsense } = useServices();

  const { data: playerData } = usePlayerQuery();

  const [game] = useAtom(getAnalysisGameAction.dataAtom);
  const [selectedMove] = useAtom(selectedMoveAtom);

  const restoringNavigationEvent = useRef(false);

  const handleCopy = () => {
    const text = toMovesPairs(game!.moves)
      .map((move) => [`${move.number}.`, move.white.san, move.black?.san].join(' '))
      .join(' ');

    copyText(text, () => {
      pushNotification({ type: 'success', title: t('analysis.pgn-copied') });
    });
  };

  const handlePlay: MouseEventHandler<HTMLButtonElement> = (event) => {
    if (restoringNavigationEvent.current) {
      restoringNavigationEvent.current = false;
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    const target = event.target;
    const clonedNativeEvent = new MouseEvent('click', event.nativeEvent);

    const restoreEvent = () => {
      restoringNavigationEvent.current = true;
      target.dispatchEvent(clonedNativeEvent);
    };

    const disabledInterstitials = SayKitWeb.featureFlags.interstitials === 'none';
    if (!disabledInterstitials) {
      Adsense.showInterstitial('start-training', restoreEvent);
    } else {
      restoreEvent();
    }
  };

  return (
    <div className={footerButtonsStyles}>
      <Button
        color="default"
        onClick={handleCopy}
        loading={!game}
        disabled={!game}
        className={classNames(buttonStyles, copyButtonStyles)}
      >
        <Icon name="chessCopy" className={buttonIconStyles} />
        {t('button.copy')}
      </Button>

      <RouterLink
        href={{
          pathname: Routes.boardEditorGame,
          query: {
            fen: selectedMove?.fen || game?.startFen,
            playerColor: game?.whitePlayerId === playerData?.player?.id ? 'w' : 'b',
            analysisId: game?.id,
          },
        }}
        className={classNames(buttonStyles, playLinkStyles)}
      >
        <Button
          color="default"
          loading={!game}
          disabled={!game}
          className={playButtonStyles}
          onClick={handlePlay}
          fullWidth
        >
          <Icon name="robot" className={buttonIconStyles} />
          {t('button.play')}
        </Button>
      </RouterLink>
    </div>
  );
};

export default PlayFromPositionButton;
